import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../../../actions/alert';
import { limpiarSubsubcategoriaConfiguracion, obtenerSubsubcategoriaConfiguracion, editarSubsubcategoriaConfiguracion } from '../../../../../actions/configuracion';

const EditarSubsubcategoria = ({ subsubcategoria, reestablecerSubsubcategoria }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.subsubcategorias);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [subsubcategoriaData, setSubsubcategoriaData] = useState({
        id: null,
        id_subcategoria: null, 
        subsubcategoria: null, 
        nombre: '', 
        descripcion: ''
    });

    /* Editar subsubcategoria */
    const handleInputChange = ({ target }) => {
        setSubsubcategoriaData({
            ...subsubcategoriaData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(subsubcategoriaData.nombre && subsubcategoriaData.id_subcategoria != 0 && subsubcategoriaData.id_subcategoria != '0'){
            await setStatusProcesar(true);
            await dispatch(editarSubsubcategoriaConfiguracion(subsubcategoriaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setSubsubcategoriaData({
                id: null,
                id_subcategoria: null, 
                nombre: '', 
                descripcion: ''
            });

            setEditarModal(false);
            reestablecerSubsubcategoria(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarSubsubcategoriaConfiguracion());
    }, []);

    useEffect(() => {
        if(subsubcategoria){
            setEditarModal(true);
            
            dispatch(obtenerSubsubcategoriaConfiguracion(subsubcategoria?.id));

            setSubsubcategoriaData({
                ...subsubcategoriaData,
                id: subsubcategoria?.id
            });
        }
    }, [subsubcategoria]);

    useEffect(() => {
        if(detalles){
            setSubsubcategoriaData({
                ...subsubcategoriaData,
                id: detalles?.id, 
                id_subcategoria: detalles?.id_subcategoria, 
                subcategoria: detalles?.id_subcategoria == 0 ? false : true,
                nombre: detalles?.nombre, 
                descripcion: detalles?.descripcion
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar subsubcategoria</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={subsubcategoriaData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control" placeholder="Descripción" id="descripcion" name="descripcion" value={subsubcategoriaData.descripcion} onChange={e => handleInputChange(e)} rows="3"></textarea>
                                <label htmlFor="descripcion">Descripción</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarSubsubcategoria;